import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { FormInputComponent, UntypedFormComponent } from '@ftr/forms'
import {
  AnchorComponent,
  FocusableNoopAnchorDirective,
  IllustrationComponent,
  NotificationModule,
  PageComponent,
} from '@ftr/foundation'
import { PasswordComponent, PasswordValidationComponent } from '@ftr/ui-password'
import { ResetAttributesService } from './reset-attributes.service'
import { ResetSentComponent } from './reset-sent/reset-sent.component'
import { ResetVerifyComponent } from './reset-verify/reset-verify.component'
import { ResetComponent } from './reset/reset.component'

@NgModule({
  imports: [
    RouterModule,
    IllustrationComponent,
    PageComponent,
    NotificationModule,
    PasswordValidationComponent,
    PasswordComponent,
    UntypedFormComponent,
    FormInputComponent,
    AnchorComponent,
    FocusableNoopAnchorDirective,
  ],
  declarations: [ResetComponent, ResetSentComponent, ResetVerifyComponent],
  providers: [ResetAttributesService],
  exports: [ResetComponent, ResetSentComponent, ResetVerifyComponent],
})
export class PasswordResetModule {}
